<template>
  <div class="row justify-content-center">
    <div class="col-12">
      <div class="card survey-panel">
        <div class="card-body">
          <div class="row align-items-center g-4">
            <div class="col-12 col-lg-7">
              <span class="badge text-bg-light border mb-3 px-3 py-2">Willkommen</span>
              <h2 class="h1 fw-semibold mb-3">Moin {{ userStore.user.first_name }}, wir richten Ihre Vermarktung gemeinsam ein.</h2>
              <p class="lead text-secondary mb-4">
                In wenigen Schritten erfassen wir, was Sie anbieten und wie Ihr Eintrag strukturiert werden soll.
              </p>
              <div class="d-flex flex-column flex-sm-row gap-2">
                <button type="button" class="btn btn-primary btn-lg px-4" @click="surveyStore.setCurrentConfig('personal_data')">
                  Fragebogen starten
                </button>
                <span class="small text-secondary align-self-center">Dauert nur wenige Minuten.</span>
              </div>
            </div>
            <div class="col-12 col-lg-5">
              <div class="bg-light border p-4 h-100">
                <h3 class="h5 fw-semibold mb-3">Was Sie erwartet</h3>
                <ul class="list-group list-group-flush">
                  <li class="list-group-item bg-transparent px-0">
                    Sie beantworten nur die Fragen, die zu Ihrem Eintrag passen.
                  </li>
                  <li class="list-group-item bg-transparent px-0">
                    Ihre Angaben helfen uns, Ihre Unterkünfte und Funktionen passend vorzubereiten.
                  </li>
                  <li class="list-group-item bg-transparent px-0 pb-0">
                    Wenn möglich, landen Sie danach direkt in der Bearbeitung Ihres neuen Eintrags.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {useSurveyStore} from "@/stores/survey";
import {useUserStore} from "@/stores/user";

export default {
  components: {
  },
  setup() {
    return {
      surveyStore: useSurveyStore(),
      userStore: useUserStore(),
    }
  },
  data() {
    return {}
  },
  props: {
    errors: Object,
  },
  methods: {},

}
</script>
